import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import {
  useIsProjectList,
  useProjectNavigation,
} from '@client/hooks/use-router.hooks';
import { useKeydownListener } from '@client/hooks/use-events.hooks';
import CloseButton from '@ui/CloseButton';
import { URL_CATEGORY_NONE } from '@client/models/router.model';

export const SidePanelCloseButton: React.FC = () => {
  const isProjectList = useIsProjectList();
  const navigateTo = useProjectNavigation();

  const closeSidePanel = useCallback(() => {
    if (isProjectList) return;
    navigateTo({ elementId: URL_CATEGORY_NONE });
  }, [navigateTo, isProjectList]);

  useKeydownListener((event) => {
    // check if event originates from an input or textarea, in that case we should not trigger
    // if we need more elements to interrupt, we can add them to the array
    const shouldInterrupt = [HTMLInputElement, HTMLTextAreaElement].some(
      (Element) => event.target instanceof Element,
    );

    if (shouldInterrupt) return;
    else closeSidePanel();
  }, 'Escape');

  return (
    <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <CloseButton onClick={closeSidePanel} />
    </Box>
  );
};
